/* Live prices and availability are rendered by Shopify; approved specifications are SKU-bound. */
(() => {
  const keys = ['cabinet','mount','layout','material','colour','availability','min','max','sort'];
  const lightColourRank = variant => ({magnolia:0,day:1,polaris:2}[variant.title.trim().toLowerCase()] ?? 100);
  function matches(variant, state) {
    const a = variant.attributes;
    return (!state.cabinet || String(a.cabinet) === state.cabinet)
      && (!state.mount || a.mount?.includes(state.mount))
      && (!state.layout || a.layout === state.layout)
      && (!state.material || (state.material === 'cristadur' ? ['cristadur','green'].includes(a.material) : a.material === state.material))
      && (!state.colour || a.colour === state.colour)
      && (!state.availability || variant.available === (state.availability === 'stock'))
      && (!state.min || variant.price >= Number(state.min) * 100)
      && (!state.max || variant.price <= Number(state.max) * 100);
  }
  class SinkFilters extends HTMLElement {
    static matches(variant,state){return matches(variant,state);}
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.grid = this.querySelector('.schock-sink-grid');
      this.cards = [...this.querySelectorAll('[data-sink-card]')].map((node,index) => ({
        node,index,variants:JSON.parse(node.querySelector('[data-sink-variants]').textContent),
        links:[...node.querySelectorAll('a[href*="/products/"]')].map(link=>({link,href:link.getAttribute('href')})),
        image:node.querySelector('.card__media img'),
        originalImage:node.querySelector('.card__media img')?.outerHTML,
        priceNode:node.querySelector('.price'),
        originalPrice:node.querySelector('.price')?.innerHTML,
        stockNode:node.querySelector('[data-stock-status]'),
        originalStock:node.querySelector('[data-stock-status]')?.innerHTML
      }));
      this.readURL(); this.apply(false); this.form.hidden = false;
      this.form.addEventListener('change',()=>this.apply(true));
      this.form.addEventListener('input',e=>{if(e.target.type==='number')this.apply(true);});
      this.form.addEventListener('submit',e=>e.preventDefault());
      this.form.addEventListener('reset',()=>setTimeout(()=>this.apply(true),0));
      this.onPop=()=>{this.readURL();this.apply(false);};
      window.addEventListener('popstate',this.onPop);
    }
    disconnectedCallback(){window.removeEventListener('popstate',this.onPop);}
    readURL(){const params=new URL(location.href).searchParams;for(const key of keys)this.form.elements[key].value=params.get('s_'+key)|| (key==='sort'?'default':'');}
    apply(writeURL){
      const state=Object.fromEntries(new FormData(this.form));
      const constrained=keys.some(k=>k!=='sort'&&state[k]);
      let count=0;
      const cards=this.cards.map(card=>{
        const variants=card.variants.filter(v=>matches(v,state));
        card.node.hidden=variants.length===0;
        if(variants.length)count++;
        const matched=[...variants].sort((a,b)=>Number(b.available)-Number(a.available)||lightColourRank(a)-lightColourRank(b))[0];
        const note=card.node.querySelector('[data-filter-match]');
        note.hidden=!constrained||!matched;
        note.textContent=matched ? `Atitinka: ${variants.map(v=>v.title).join(', ')}` : '';
        for(const {link,href} of card.links){const url=new URL(href,location.origin);if(matched)url.searchParams.set('variant',matched.id);link.setAttribute('href',matched?url.pathname+url.search:href);}
        if(card.image){
          if(matched?.image){card.image.src=matched.image;card.image.removeAttribute('srcset');card.image.alt=`${card.node.dataset.title} – ${matched.title}`;}
          else if(card.originalImage){card.image.outerHTML=card.originalImage;card.image=card.node.querySelector('.card__media img');}
        }
        if(card.priceNode){
          if(matched)card.priceNode.textContent=new Intl.NumberFormat('lt-LT',{style:'currency',currency:'EUR'}).format(matched.price/100);
          else card.priceNode.innerHTML=card.originalPrice;
        }
        if(card.stockNode){
          if(matched){
            card.stockNode.textContent=matched.delivery || (matched.available?'Pristatymas iki 3 darbo dienų':'Pristatymas iki 4 savaičių');
            const colour=document.createElement('small');colour.textContent=matched.title;card.stockNode.append(colour);
          }
          else card.stockNode.innerHTML=card.originalStock;
        }
        return {...card,inStock:variants.some(v=>v.available),price:variants.length?Math.min(...variants.map(v=>v.price)):Infinity};
      });
      cards.sort((a,b)=>state.sort==='price-asc'?a.price-b.price:state.sort==='price-desc'?b.price-a.price:state.sort==='title'?a.node.dataset.title.localeCompare(b.node.dataset.title,'lt'):Number(b.inStock)-Number(a.inStock)||a.index-b.index);
      cards.forEach(c=>this.grid.append(c.node));
      this.querySelector('[data-filter-count]').textContent=`Rodoma modelių: ${count} iš ${cards.length}`;
      this.querySelector('[data-filter-empty]').hidden=count!==0;
      if(writeURL){const url=new URL(location.href);for(const key of keys){url.searchParams.delete('s_'+key);if(state[key]&&state[key]!=='default')url.searchParams.set('s_'+key,state[key]);}if(url.href!==location.href)history.pushState({},'',url);}
    }
  }
  if(!customElements.get('schock-sink-filters'))customElements.define('schock-sink-filters',SinkFilters);
})();
